import Axios from "axios";
import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";

/** Visit-only workplace rows (same as GET /booking-schedule/place with visitOnly=true). */
export const fetchVisitOnlySchedule = (bookingScheduleDto: BookingScheduleDto) => {
  const params: Record<string, unknown> = {
    userIds: bookingScheduleDto.userIds
  };
  if (bookingScheduleDto.startDate) {
    params.startDate = bookingScheduleDto.startDate;
  }
  if (bookingScheduleDto.endDate) {
    params.endDate = bookingScheduleDto.endDate;
  }
  return Axios.get<BookingScheduleInterface[]>(`/booking-schedule/visit-only`, { params });
};
